<div class="modal-header">
  <h4 class="modal-title">Linked Companies</h4>
  <button type="button" class="btn-close" data-dismiss="modal" tabindex="-1" (click)="reset()" aria-label="Close"></button>
</div>

<div class="modal-body">
  <h5>{{ branch.BusinessName }}</h5>
@if (activeLicense()) {
  <div class="d-grid gap-1">
    <div>{{ activeLicense().FullAddress }}</div>
    <div>+{{ activeLicense().ContactNo }}</div>
  @if (activeLicense().Email) {
    <div>{{ activeLicense().Email }}</div>
  }
    <div>Valid from {{ activeLicense().ValidSince | date: "dd MMM yyyy" }} to {{ activeLicense().ValidUntil | date: "dd MMM yyyy" }}</div>
  </div>
} @else {
  <div class="fs-6 badge bg-danger-subtle text-danger-emphasis border-danger-subtle">No active license</div>
}
  <hr class="mb-1" />
  <table class="table table-responsive table-custom mb-0 pb-4">
    <thead>
      <tr>
        <th>Companies ({{ branch.LinkedCompanyCount }})</th>
        <th></th>
      </tr>
    </thead>
    <tbody>
    @for (company of companyList; track company.ID) {
      <tr>
        <td>{{ company.ID }} - {{ company.CompanyCode }}</td>
        <td class="text-end"><i class="fas fa-exchange-alt" style="cursor: pointer; color: #878787" (click)="changeBranch(company)"></i></td>
      </tr>
    }
    </tbody>
  </table>
</div>
